var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGranules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.475,
    height: 51.339,
    viewBox: "0 0 56.475 51.339",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_287",
    "data-name": "Rectangle 287",
    width: 56.475,
    height: 51.339,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_269",
    "data-name": "Groupe 269",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_268",
    "data-name": "Groupe 268",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_473",
    "data-name": "Trac\\xE9 473",
    d: "M23.624,13.775a.866.866,0,0,1-.839-.658L19.811,1.071a.865.865,0,1,1,1.68-.414L24.465,12.7a.865.865,0,0,1-.632,1.047.909.909,0,0,1-.209.025",
    transform: "translate(-2.667 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_474",
    "data-name": "Trac\\xE9 474",
    d: "M35.1,11.857a.878.878,0,0,1-.243-.035.865.865,0,0,1-.587-1.073l2.89-9.9a.865.865,0,0,1,1.661.485l-2.891,9.9a.864.864,0,0,1-.83.623",
    transform: "translate(-4.615 -0.032)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_475",
    "data-name": "Trac\\xE9 475",
    d: "M43.9,17.279a.865.865,0,0,1-.473-1.59L53.5,9.122a.865.865,0,1,1,.945,1.45L44.372,17.139a.868.868,0,0,1-.472.14",
    transform: "translate(-5.802 -1.211)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_476",
    "data-name": "Trac\\xE9 476",
    d: "M4.692,56.012a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(0 -7.059)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_477",
    "data-name": "Trac\\xE9 477",
    d: "M64.208,56.3a2.491,2.491,0,1,1-1.035-3.366A2.49,2.49,0,0,1,64.208,56.3",
    transform: "translate(-8.024 -7.098)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_478",
    "data-name": "Trac\\xE9 478",
    d: "M18.531,56.98A2.491,2.491,0,1,1,17.5,53.614a2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-1.866 -7.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_479",
    "data-name": "Trac\\xE9 479",
    d: "M50.369,57.077a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-6.158 -7.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_480",
    "data-name": "Trac\\xE9 480",
    d: "M45.255,52.593a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-5.469 -6.598)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_481",
    "data-name": "Trac\\xE9 481",
    d: "M23.079,52.432a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-2.479 -6.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_482",
    "data-name": "Trac\\xE9 482",
    d: "M31.513,52.69a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-3.616 -6.611)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_483",
    "data-name": "Trac\\xE9 483",
    d: "M37.127,52.534a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-4.373 -6.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_484",
    "data-name": "Trac\\xE9 484",
    d: "M31.8,42.819a2.491,2.491,0,1,1-1.036-3.366A2.492,2.492,0,0,1,31.8,42.819",
    transform: "translate(-3.655 -5.28)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_485",
    "data-name": "Trac\\xE9 485",
    d: "M37.418,42.663A2.491,2.491,0,1,1,36.383,39.3a2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-4.412 -5.259)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_486",
    "data-name": "Trac\\xE9 486",
    d: "M41.287,37.98a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-4.934 -4.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_487",
    "data-name": "Trac\\xE9 487",
    d: "M45.545,37.786A2.491,2.491,0,1,1,44.51,34.42a2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-5.508 -4.602)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_488",
    "data-name": "Trac\\xE9 488",
    d: "M27.434,37.916A2.491,2.491,0,1,1,26.4,34.55a2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-3.066 -4.619)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_489",
    "data-name": "Trac\\xE9 489",
    d: "M23.37,37.625a2.491,2.491,0,1,1-1.036-3.366,2.492,2.492,0,0,1,1.036,3.366",
    transform: "translate(-2.518 -4.58)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_490",
    "data-name": "Trac\\xE9 490",
    d: "M31.9,32.948a2.491,2.491,0,1,1-1.035-3.366A2.49,2.49,0,0,1,31.9,32.948",
    transform: "translate(-3.668 -3.949)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_491",
    "data-name": "Trac\\xE9 491",
    d: "M37.514,32.792a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-4.425 -3.928)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_492",
    "data-name": "Trac\\xE9 492",
    d: "M41.384,33.044a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-4.947 -3.962)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_493",
    "data-name": "Trac\\xE9 493",
    d: "M27.531,32.98A2.491,2.491,0,1,1,26.5,29.614a2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-3.079 -3.954)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_494",
    "data-name": "Trac\\xE9 494",
    d: "M31.8,37.883a2.491,2.491,0,1,1-1.036-3.366A2.492,2.492,0,0,1,31.8,37.883",
    transform: "translate(-3.655 -4.615)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_495",
    "data-name": "Trac\\xE9 495",
    d: "M37.418,37.727a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-4.412 -4.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_496",
    "data-name": "Trac\\xE9 496",
    d: "M45.545,42.722a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-5.508 -5.267)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_497",
    "data-name": "Trac\\xE9 497",
    d: "M23.37,42.561a2.491,2.491,0,1,1-1.036-3.366,2.492,2.492,0,0,1,1.036,3.366",
    transform: "translate(-2.518 -5.245)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_498",
    "data-name": "Trac\\xE9 498",
    d: "M18.821,42.658a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-1.905 -5.259)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_499",
    "data-name": "Trac\\xE9 499",
    d: "M50.66,42.754a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-6.197 -5.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_500",
    "data-name": "Trac\\xE9 500",
    d: "M34.76,25.359a2.49,2.49,0,1,1-.824-3.424,2.49,2.49,0,0,1,.824,3.424",
    transform: "translate(-4.064 -2.908)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_501",
    "data-name": "Trac\\xE9 501",
    d: "M31.824,28.94A2.49,2.49,0,1,1,31,25.516a2.49,2.49,0,0,1,.824,3.424",
    transform: "translate(-3.668 -3.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_502",
    "data-name": "Trac\\xE9 502",
    d: "M37.437,29.133a2.49,2.49,0,1,1-.824-3.424,2.49,2.49,0,0,1,.824,3.424",
    transform: "translate(-4.425 -3.417)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_503",
    "data-name": "Trac\\xE9 503",
    d: "M41.287,42.915a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-4.934 -5.293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_504",
    "data-name": "Trac\\xE9 504",
    d: "M27.434,42.851A2.491,2.491,0,1,1,26.4,39.485a2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-3.066 -5.285)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_505",
    "data-name": "Trac\\xE9 505",
    d: "M18.531,47.593A2.491,2.491,0,1,1,17.5,44.227a2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-1.866 -5.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_506",
    "data-name": "Trac\\xE9 506",
    d: "M13.886,47.5a2.491,2.491,0,1,1-1.035-3.366A2.49,2.49,0,0,1,13.886,47.5",
    transform: "translate(-1.239 -5.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_507",
    "data-name": "Trac\\xE9 507",
    d: "M50.369,47.69a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-6.158 -5.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_508",
    "data-name": "Trac\\xE9 508",
    d: "M55.015,47.5A2.491,2.491,0,1,1,53.98,44.13,2.49,2.49,0,0,1,55.015,47.5",
    transform: "translate(-6.784 -5.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_509",
    "data-name": "Trac\\xE9 509",
    d: "M41,47.851a2.491,2.491,0,1,1-1.035-3.366A2.49,2.49,0,0,1,41,47.851",
    transform: "translate(-4.895 -5.959)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_510",
    "data-name": "Trac\\xE9 510",
    d: "M27.144,47.787a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-3.027 -5.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_511",
    "data-name": "Trac\\xE9 511",
    d: "M31.513,47.754a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-3.616 -5.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_512",
    "data-name": "Trac\\xE9 512",
    d: "M37.127,47.6a2.491,2.491,0,1,1-1.035-3.366A2.49,2.49,0,0,1,37.127,47.6",
    transform: "translate(-4.373 -5.925)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_513",
    "data-name": "Trac\\xE9 513",
    d: "M45.255,47.657a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-5.469 -5.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_514",
    "data-name": "Trac\\xE9 514",
    d: "M23.079,47.5a2.491,2.491,0,1,1-1.035-3.366A2.49,2.49,0,0,1,23.079,47.5",
    transform: "translate(-2.479 -5.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_515",
    "data-name": "Trac\\xE9 515",
    d: "M18.531,52.529A2.491,2.491,0,1,1,17.5,49.163a2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-1.866 -6.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_516",
    "data-name": "Trac\\xE9 516",
    d: "M13.886,52.432a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-1.239 -6.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_517",
    "data-name": "Trac\\xE9 517",
    d: "M8.95,52.335a2.491,2.491,0,1,1-1.035-3.366A2.49,2.49,0,0,1,8.95,52.335",
    transform: "translate(-0.574 -6.563)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_518",
    "data-name": "Trac\\xE9 518",
    d: "M50.369,52.625a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-6.158 -6.602)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_519",
    "data-name": "Trac\\xE9 519",
    d: "M55.015,52.432a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-6.784 -6.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_520",
    "data-name": "Trac\\xE9 520",
    d: "M59.563,52.722a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-7.398 -6.615)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_521",
    "data-name": "Trac\\xE9 521",
    d: "M41,52.786a2.491,2.491,0,1,1-1.035-3.366A2.49,2.49,0,0,1,41,52.786",
    transform: "translate(-4.895 -6.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_522",
    "data-name": "Trac\\xE9 522",
    d: "M27.144,52.722a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-3.027 -6.615)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_523",
    "data-name": "Trac\\xE9 523",
    d: "M45.255,57.044a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-5.469 -7.198)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_524",
    "data-name": "Trac\\xE9 524",
    d: "M23.079,56.883a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-2.479 -7.176)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_525",
    "data-name": "Trac\\xE9 525",
    d: "M13.886,56.883a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-1.239 -7.176)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_526",
    "data-name": "Trac\\xE9 526",
    d: "M8.95,56.787a2.491,2.491,0,1,1-1.035-3.366A2.49,2.49,0,0,1,8.95,56.787",
    transform: "translate(-0.574 -7.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_527",
    "data-name": "Trac\\xE9 527",
    d: "M55.015,56.883a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-6.784 -7.176)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_528",
    "data-name": "Trac\\xE9 528",
    d: "M59.563,57.174a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-7.398 -7.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_529",
    "data-name": "Trac\\xE9 529",
    d: "M41,57.238a2.491,2.491,0,1,1-1.035-3.366A2.49,2.49,0,0,1,41,57.238",
    transform: "translate(-4.895 -7.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_530",
    "data-name": "Trac\\xE9 530",
    d: "M27.144,57.174a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-3.027 -7.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_531",
    "data-name": "Trac\\xE9 531",
    d: "M31.513,57.141a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-3.616 -7.211)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_532",
    "data-name": "Trac\\xE9 532",
    d: "M37.127,56.985a2.491,2.491,0,1,1-1.035-3.366,2.49,2.49,0,0,1,1.035,3.366",
    transform: "translate(-4.373 -7.19)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGranules);
export default __webpack_public_path__ + "static/media/GRANULES.9420f77a39d738f8e7ef33bdb2a72a22.svg";
export { ForwardRef as ReactComponent };